import styled from "styled-components";

export const TitleH = styled.h1`
  font-size: 42px;
  text-align: center;
  margin-bottom: 110px;
`;
